import { render, staticRenderFns } from "./PoiOplocFields.vue?vue&type=template&id=72a2322d"
import script from "./PoiOplocFields.js?vue&type=script&lang=js&external"
export * from "./PoiOplocFields.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports